export default __webpack_public_path__ + "static/use-body-text-do-683040cc91038aba4ae8168b7709c7619abeed69a1e041e35ac3b107de19303c.png";